(function () {
    'use strict';

    angular.module("imApp").factory("tracesBService", ['$ihttp', function ($ihttp) {
        let service = {
            getTracesB: function (parms) {
                return $ihttp.post({
                    method: 2455,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
